import React from "react";
import { WelcomeScreen } from "@excalidraw/excalidraw/index";

// pro100доска: welcome screen is just the standalone centered wordmark now —
// no tagline, no menu list, no hint arrows (those pointed at menu items that
// no longer exist here; Open/Help/Поделиться/Мои доски all live in the
// bottom dock instead, see LayerUI.tsx).
export const AppWelcomeScreen: React.FC<{
  onCollabDialogOpen: () => any;
  isCollabEnabled: boolean;
}> = React.memo(() => {
  return (
    <WelcomeScreen>
      <WelcomeScreen.Center>
        <WelcomeScreen.Center.Logo />
      </WelcomeScreen.Center>
    </WelcomeScreen>
  );
});
